// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2Izjo","content":"ManualTimeModal_content__5l55X"};